const map = new Map<string, Promise<Response>>();

export default async (
  input: RequestInfo | URL,
  init?: RequestInit,
  forceUpdate = false,
): Promise<Response> => {
  if (init?.method && init.method.toLowerCase() !== 'get') {
    throw new Error('Function only works with GET requests');
  }

  const uri = input.toString();
  let request = map.get(uri);

  if (!request || forceUpdate) {
    request = fetch(input, init);
    map.set(uri, request);
  }

  const response = await request;

  if (!response.ok) {
    map.delete(uri);
  }

  return response.clone();
};
